"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendCodeSucceed = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const sendCodeSucceed = exports.sendCodeSucceed = (0, _actionGenerator.actionGenerator)(_types.ETwoFactorPhoneActionTypes.SendCodeSucceed);